function Header() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById("pricing")
    pricingSection?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <div className="text-xl sm:text-2xl font-bold text-black">
          planer-intent.ru
        </div>
        <button
          onClick={scrollToPricing}
          className="bg-[#F45B3C] text-white font-semibold px-4 sm:px-6 py-2 sm:py-3 rounded-lg hover:bg-[#D32F2F] transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 text-sm sm:text-base"
        >
          Забрать за 590₽
        </button>
      </div>
    </header>
  )
}

export default Header
